import React from "react";
import {
  Grid,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { AutocompleteComponent } from "../../components/Autocomplete/AutocompleteComponent";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { isAlphanumeric, isNumeric } from "../../helpers/regexFunctions";
import { useBillingForm } from "./hooks";

export const AdminUnitsBillingForm = ({
  data = {},
  setOpen = () => {},
  open = false,
  title,
}) => {
  const {
    values,
    onChange,
    setValues,
    errors,
    onChangeNumberV2,
    handleValidatedChange,
    handleSubmit,
    isLoadingComp,
    stationsList,
    licenseOptions,
  } = useBillingForm(data, setOpen);

  const {
    selectedStation,
    selectedCreLicense,
    unitPlates,
    insurance,
    insurancePolicy,
    insurancePolicyValue,
    insurancePolicyValue_,
    unitModel,
    unitWeight,
    unitWeight_,
    kmEstimation,
    kmEstimation_,
    vehicleConfig,
  } = values;

  return (
    <ModalV2
      title={title}
      open={open}
      onClose={setOpen}
      onSubmit={handleSubmit}
      submitBtnText="Guardar"
      toRight
      isLoading={isLoadingComp?.createBill || isLoadingComp?.editBill}
    >
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Planta"
          name="selectedStation"
          value={selectedStation}
          handleValues={setValues}
          fullWidth
          variant="outlined"
          textFieldProps={{
            error: !!errors.selectedStation,
            helperText: errors.selectedStation,
          }}
          options={stationsList}
          sort={true}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <AutocompleteComponent
          label="Permiso CRE"
          name="selectedCreLicense"
          keyOption="creLicense"
          value={selectedCreLicense}
          handleValues={setValues}
          fullWidth
          variant="outlined"
          textFieldProps={{
            error: !!errors.selectedCreLicense,
            helperText: errors.selectedCreLicense,
          }}
          options={licenseOptions}
          sort={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Placas"
          name="unitPlates"
          value={unitPlates}
          onChange={onChange}
          fullWidth
          variant="outlined"
          error={!!errors.unitPlates}
          helperText={errors.unitPlates}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Aseguradora"
          name="insurance"
          value={insurance}
          onChange={onChange}
          fullWidth
          variant="outlined"
          error={!!errors.insurance}
          helperText={errors.insurance}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Póliza de seguro"
          name="insurancePolicy"
          value={insurancePolicy}
          onChange={handleValidatedChange(isAlphanumeric)}
          fullWidth
          variant="outlined"
          error={!!errors.insurancePolicy}
          helperText={errors.insurancePolicy}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Valor de la póliza"
          name="insurancePolicyValue"
          value={insurancePolicyValue_ || insurancePolicyValue}
          onChange={(e) => onChangeNumberV2(e, { decimals: 2 })}
          fullWidth
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment style={{ marginLeft: 8 }} position="start">
                $
              </InputAdornment>
            ),
          }}
          error={!!errors.insurancePolicyValue}
          helperText={errors.insurancePolicyValue}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Modelo"
          name="unitModel"
          value={unitModel}
          onChange={handleValidatedChange(isNumeric)}
          fullWidth
          variant="outlined"
          inputProps={{ maxLength: 4 }}
          error={!!errors.unitModel}
          helperText={errors.unitModel}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Peso del vehículo"
          name="unitWeight"
          value={unitWeight_ || unitWeight}
          onChange={(e) => onChangeNumberV2(e, { decimals: 2 })}
          fullWidth
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment style={{ marginLeft: 8 }} position="end">
                ton
              </InputAdornment>
            ),
            inputProps: { style: { textAlign: "right" } },
          }}
          error={!!errors.unitWeight}
          helperText={errors.unitWeight}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Distancia estimada"
          name="kmEstimation"
          value={kmEstimation_ || kmEstimation}
          onChange={(e) => onChangeNumberV2(e, { decimals: 2 })}
          fullWidth
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment style={{ marginLeft: 8 }} position="end">
                km
              </InputAdornment>
            ),
            inputProps: { style: { textAlign: "right" } },
          }}
          error={!!errors.kmEstimation}
          helperText={errors.kmEstimation}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Configuración vehicular"
          name="vehicleConfig"
          value={vehicleConfig}
          onChange={handleValidatedChange(isAlphanumeric)}
          fullWidth
          variant="outlined"
          error={!!errors.vehicleConfig}
          helperText={errors.vehicleConfig}
        />
      </Grid>
    </ModalV2>
  );
};
